import { KioskConnectivityEventCentre } from './kioskConnectivity.eventCentre';
import { useSignalRService } from '../useSignalRService.hook';
import { useEffect, useMemo } from 'react';
import {
  KioskConnectivitySubscriptionMatcher,
  KioskConnectivitySubscriptionCallback,
  KioskConnectivitySubscriptionStream
} from './kioskConnectivity.types';

export function useKioskConnectivityEventCentre({
  callback,
  matcher,
  stream
}: {
  callback: KioskConnectivitySubscriptionCallback;
  matcher: KioskConnectivitySubscriptionMatcher;
  stream: KioskConnectivitySubscriptionStream;
}) {
  const signalR = useSignalRService();
  const kioskConnectivity = KioskConnectivityEventCentre.getInstance(signalR);

  const subscription = useMemo(() => kioskConnectivity.subscribe(), [kioskConnectivity]);

  useEffect(() => {
    subscription.setCallback(callback);
  }, [callback, subscription]);

  useEffect(() => {
    subscription.setMatcher(matcher);
  }, [matcher, subscription]);

  useEffect(() => {
    if (stream.iotHubIDs.length === 0) {
      return;
    }
    subscription.stream(stream);
  }, [stream, subscription]);

  useEffect(() => {
    return () => subscription.unsubscribe();
  }, [subscription]);

  return subscription;
}
